import actions, { getView } from './actions';
import { isServer } from '@iso/lib/helpers/isServer';

const initState = {
  collapsed: !isServer && window.innerWidth > 1220 ? false : true,
  view: !isServer && getView(window.innerWidth),
  height: !isServer && window.innerHeight,
  openDrawer: false,
  selectedKeys: [],
  openKeys: [],
};

export default function appReducer(state = initState, action) {
  switch (action.type) {
    case actions.CHANGE_COLLAPSE:
      return {
        ...state,
        collapsed: !state.collapsed,
      };
    case actions.CLOSE_COLLAPSE:
      return {
        ...state,
        collapsed: true,
      };
    case actions.OPEN_COLLAPSE:
      return {
        ...state,
        openDrawer: !state.openDrawer,
      };
    case actions.TOGGLE_ALL:
      if (state.view !== action.view || action.height !== state.height) {
        const height = action.height ? action.height : state.height;
        return {
          ...state,
          collapsed: action.collapsed,
          view: action.view,
          height,
        };
      }
      break;
    case actions.SELECTED_KEYS:
      return {
        ...state,
        selectedKeys: action.selectedKeys,
      };
    case actions.OPEN_KEYS:
      return {
        ...state,
        openKeys: action.openKeys,
      };
    default:
      return state;
  }
  return state;
}
